const BASE = (process.env.REACT_APP_BACKEND_URL || '/backend').replace(/\/+$/, '');

const apiFetch = async (action: string, opts: RequestInit = {}) => {
  const url = `${BASE}/api.php?action=${action}`;
  const res = await fetch(url, { credentials: 'include', ...opts });
  const data = await res.json();
  if (!res.ok) throw data;
  return data;
};

export const me = () => apiFetch('me');

export const login = (username: string, password: string) => apiFetch('login', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ username, password }) });
export const logout = () => apiFetch('logout', { method: 'POST' });

// Portfolio
export const getPortfolio = () => apiFetch('get_portfolio');
export const createPortfolio = (payload: any) => apiFetch('create_portfolio', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
export const updatePortfolio = (payload: any) => apiFetch('update_portfolio', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
export const deletePortfolio = (id: number) => apiFetch(`delete_portfolio&id=${id}`, { method: 'POST' });

// Services
export const getServices = () => apiFetch('get_services');
export const createService = (payload: any) => apiFetch('create_service', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
export const updateService = (payload: any) => apiFetch('update_service', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
export const deleteService = (id: number) => apiFetch(`delete_service&id=${id}`, { method: 'POST' });

// Quotes
export const getQuotes = () => apiFetch('get_quotes');
export const createQuote = (payload: any) => apiFetch('create_quote', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
export const updateQuoteStatus = (payload: any) => apiFetch('update_quote_status', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
export const deleteQuote = (id: number) => apiFetch(`delete_quote&id=${id}`, { method: 'POST' });

// Upload helpers (multipart)
export const uploadFile = async (file: File) => {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${BASE}/api.php?action=upload_file`, { method: 'POST', body: fd, credentials: 'include' });
  const data = await res.json();
  if (!res.ok) throw data;
  return data;
};

export const uploadFiles = async (files: FileList | File[]) => {
  const fd = new FormData();
  for (const f of Array.from(files as any) as File[]) fd.append('files[]', f);
  const res = await fetch(`${BASE}/api.php?action=upload_files`, { method: 'POST', body: fd, credentials: 'include' });
  const data = await res.json();
  if (!res.ok) throw data;
  return data;
};

export const deleteUploadedFile = (url: string, projectId = 0) => apiFetch('delete_uploaded_file', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ url, projectId }) });

export default apiFetch;
